export const GET_SHOP_INVOICES = "SHOP/GET_SHOP_INVOICES";
export const GET_SHOP_INVOICES_API_SUCCESS = "SHOP/GET_SHOP_INVOICES_API_SUCCESS";
export const GET_SHOP_INVOICES_API_FAILED = "SHOP/GET_SHOP_INVOICES_API_FAILED";
export const PUSH_INVOICES = "SHOP/PUSH_INVOICES";
